import axios from 'axios';

const API_URL = 'http://localhost:3000/api/blogs';

export const fetchBlogs = async () => {
    try {
        const response = await axios.get(API_URL);
        console.log("[fetchBlogs] : ",response.data)
        return response.data;
    } catch (error) {
        console.error('Error fetching blogs:', error);
        throw error;
    }
};

export const fetchByBlogType = async (blogType) =>{
    try {
        console.log("blogType : ",blogType);
        if(blogType === "motorcycle-blogs"){
          blogType = "MOTORCYCLE"
        }else if(blogType === "car-blogs"){
          blogType = "CARS"
        }else if(blogType === "safety-blogs"){
          blogType = "SAFETY"
        }else if(blogType === "tech-blogs"){
          blogType = "TECH"
        }

        
        const response = await axios.get(`${API_URL}/${blogType}`)
        return response.data;
    } catch (error) {
        
    }
}
export const getBlogBySlug = async (blogType,slug) => {
          const response = await axios.get(`${API_URL}/${blogType}/${slug}`)
          return response.data;
}

export const createBlog = async (blogData) => {
  try {
    const formData = new FormData();

    /**
     * Append Normal Fields
     */
    formData.append("title", blogData.title || "");
    formData.append("author", blogData.author || "");
    formData.append("content", blogData.content || "");
    formData.append("blogType", blogData.blogType || "");

    /**
     * Append Arrays (IMPORTANT FIX)
     */
    if (Array.isArray(blogData.categories)) {
      blogData.categories.forEach((cat) => {
        formData.append("categories", cat);
      });
    }

    if (Array.isArray(blogData.keywords)) {
      blogData.keywords.forEach((key) => {
        formData.append("keywords", key);
      });
    }

    /**
     * Append Files (IMPORTANT FIX)
     */
    if (blogData.coverImage instanceof File) {
      formData.append("coverImage", blogData.coverImage);
    }

    if (blogData.featureImage instanceof File) {
      formData.append("featureImage", blogData.featureImage);
    }

    /**
     * Debug (optional)
     */
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    /**
     * API Call
     * ⚠️ Do NOT manually set Content-Type
     */
    const response = await axios.post(API_URL, formData);

    return response.data;

  } catch (error) {
    console.error("Error creating blog:", error);
    throw error;
  }
};